import { Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpHeaders
} from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { JwtAuthService } from "../services/auth/jwt-auth.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { catchError } from "rxjs/operators";
import { AppConfirmService } from './../services/app-confirm/app-confirm.service';
import { Router } from "@angular/router";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private contextResetPromptOpen = false;

  constructor(private jwtAuth: JwtAuthService, private appConfirmService: AppConfirmService, private router: Router) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // req.url.
    const re = 'viacep.com.br/ws';
    const r2 = '/receitaws/';

    // Exclude interceptor for login request:
    const publicAuthEndpoints = [
      '/auth/signin',
      '/auth/signup',
      '/auth/recovery/pass',
      '/auth/email/confirma',
      '/email/change/pass',
      '/auth/user/confirm'
    ];

    const isPublicAuthRequest = publicAuthEndpoints.some(path => req.url.includes(path));

    if (req.url.search(re) > -1 || req.url.search(r2) > -1 || isPublicAuthRequest) {
      return next.handle(req);
    }
    const correiosSoap = '/calculador/';
    if (req.url.search(correiosSoap) > -1) {
      let headers = new HttpHeaders();
      headers = headers.append('Content-Type', 'xml/text');
      req.clone({ headers: headers });
      return next.handle(req);
    }


    //  const loja$ = this.jwtAuth.getLojaSeleted$();
    //  const authReq = req.clone({headers:
    //      (loja$ != null &&  loja$.getValue() != null &&
    //      req.url.search(loja$.getValue().url_api) > -1 ) ? this.getHeadersLoja() :  this.getHeaders()});
    //   console.log('COLOCANDO TOKEN:' + localStorage.getItem('token') + '\n na CHAMADA' + req.url );



    var token = this.jwtAuth.token || this.jwtAuth.getJwtToken();
    // console.log('ITEM EM REQ:' + JSON.stringify(this.jwtAuth.item$?.value) + '\n na CHAMADA' + req.url );

    if (this.jwtAuth.item$?.value?.remoto && this.jwtAuth.item$?.value?.empresaRemota !== null
      && this.jwtAuth.item$?.value?.empresaRemota !== undefined && req.url.search(this.jwtAuth.item$?.value?.empresaRemota.urlApi) > -1) {
      token = this.jwtAuth.tokenRemoto || this.jwtAuth.getJwtTokenRemoto();
      // console.log('COLOCANDO TOKEN:' + token + '\n na CHAMADA' + req.url );
    }
    var changedReq;

    if (token) {

      changedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        },
      });

    } else {

      changedReq = req;
    }



    return next.handle(changedReq).pipe(catchError(x => this.handleAuthError(x)));
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (this.isEmpresaContextError(err)) {
      this.promptSelecionarEmpresaNovamente();
      return throwError(err);
    }

    if (err.status === 403) {
      this.appConfirmService.confirm({
        title: 'A T E N Ç Ã O !', message:
          'Não Autorizado!Você não tem autorização p/ fazer esta operação, contate o Administrador!', error: true
      })
      console.log('Não Autorizado!Você não tem autorização p/ fazer esta operação, contate o Administrador!');

      return of(err.message);

    } else if (err.status === 401) {

    }
    return throwError(err);
  }

  private promptSelecionarEmpresaNovamente(): void {
    if (this.contextResetPromptOpen) {
      return;
    }

    this.contextResetPromptOpen = true;
    this.jwtAuth.clear();

    this.appConfirmService.confirm({
      title: 'Sessão sem empresa ativa',
      message: 'Sua sessão perdeu o contexto da empresa/filial. Selecione a empresa novamente para continuar.',
      error: true,
      okText: 'Selecionar empresa',
      cancelText: 'Sair'
    }).subscribe((confirmado) => {
      this.contextResetPromptOpen = false;
      if (confirmado) {
        this.router.navigateByUrl('/profile/filial');
        return;
      }

      this.jwtAuth.signout();
    });
  }

  private isEmpresaContextError(err: HttpErrorResponse): boolean {
    // Não interromper o fluxo intencional de troca de empresa ou autenticação
    const url = err.url ?? '';
    if (url.includes('/me/empresa/select/')
      || url.includes('/auth/signin')
      || url.includes('/auth/signup')
      || url.includes('/auth/recovery')) {
      return false;
    }

    const msg = this.extractErrorMessage(err).toLowerCase();
    if (!msg) {
      return false;
    }

    return msg.includes('filial não encontrado')
      || msg.includes('filial nao encontrado')
      || msg.includes('filial não encontrada')
      || msg.includes('filial nao encontrada')
      || msg.includes('empresa não encontrada')
      || msg.includes('empresa nao encontrada')
      || msg.includes('não foi possível determinar a filial')
      || msg.includes('nao foi possivel determinar a filial')
      || msg.includes('user not found with id');
  }

  private extractErrorMessage(err: HttpErrorResponse): string {
    if (!err) {
      return '';
    }

    const e = err.error;
    if (typeof e === 'string') {
      return e;
    }

    if (e && typeof e === 'object') {
      const status = (e.status ?? '').toString();
      const message = (e.message ?? '').toString();
      const error = (e.error ?? '').toString();
      return [status, message, error].filter(Boolean).join(' | ');
    }

    return (err.message ?? '').toString();
  }

 

 


}
